import React from "react";
import moment from "moment";


const formatDateTime = (value) => {
    const parsed = value ? moment(value) : null;

    return parsed?.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : "—";
};

const StaffManagementPeriodField = ({ startAt, endAt }) => (
    <span className="d-flex flex-column staff-management-list__period">
        <span>{ formatDateTime(startAt) } -</span>
        <span>{ formatDateTime(endAt) }</span>
    </span>
);

export default StaffManagementPeriodField;
